import { Tooltip } from "#shared/view/designSystem/Tooltip";

type ConditionalTooltipProps = {
  show: boolean;
  label?: string;
  children?: React.ReactNode;
};

const ConditionalTooltip = ({ show, label, children }: ConditionalTooltipProps) => {
  if (show && label) {
    return (
      <Tooltip label={label} multiline w={300}>
        {children}
      </Tooltip>
    );
  }

  return children;
};

export default ConditionalTooltip;
